/**
 * SuspenseFallback — default loading UI for lazy-loaded routes.
 */

import { LoadingState } from '@/components/ui';

export function SuspenseFallback(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingState />
    </div>
  );
}
